import t from './story03.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,
  regionName: t.regionName,

  prose: [
    // Run 1 — the open, no heading. Seven paragraphs before the first figure.
    [
      { text: t.s1P1 },
      { text: t.s1P2 },
      { text: t.s1P3 },
      { text: t.s1P4 },
      { text: t.s1P5 },
      { text: t.s1P6 },
      { text: t.s1P7 },
    ],
    // Run 2 — continues after the dried-up laguna figure.
    [{ text: t.s2P1 }, { text: t.s2P2 }],
    // Run 3 — first themed section.
    [{ title: t.s3Title, text: t.s3P1 }, { text: t.s3P2 }, { text: t.s3P3 }],
    // Run 4 — continues after the Cabello pull quote.
    [{ text: t.s4P1 }, { text: t.s4P2 }, { text: t.s4P3 }, { text: t.s4P4 }],
    // Run 5 — second themed section.
    [{ title: t.s5Title, text: t.s5P1 }, { text: t.s5P2 }],
    // Run 6 — continues after the mining-landscape figure.
    [{ text: t.s6P1 }, { text: t.s6P2 }, { text: t.s6P3 }, { text: t.s6P4 }],
    // Run 7 — third themed section.
    [{ title: t.s7Title, text: t.s7P1 }, { text: t.s7P2 }],
    // Run 8 — the close, after the Atacama Desert figure.
    [
      { text: t.s8P1 },
      { text: t.s8P2 },
      { text: t.s8P3 },
      { text: t.s8P4 },
      { text: t.s8P5 },
    ],
  ],

  captions: [
    // 01 — hero: lithium mining in the salt flat.
    [t.f1P1],
    // 02 — the laguna that has almost run dry.
    [t.f2P1],
    // 03 — mining scars across the landscape.
    [t.f3P1],
    // 04 — the desert itself.
    [t.f4P1],
  ],

  quotes: [
    {
      text: t.q1,
      attribution: t.q1Attr,
    },
  ],
} as const
